import React from 'react'
import LearnMoreLink from '../shared/LearnMoreLink'
import SectionHeader from '../shared/SectionHeader'
import Section from '../shared/Section'
import CustomButton from '../shared/CustomButton'
import error404 from '../assets/images/illustrations/error-404.png'
import { useRouter } from '../hooks/use-router'
import { PageNotFoundStyle } from '../shared/CommonStyle/PageNotFound'
import { isLoggedIn } from '../utils/localStorage'

const NotFound = () => {
  const classes = PageNotFoundStyle()
  const { history } = useRouter()
  const { loggedIn } = isLoggedIn()

  return (
    <div className={loggedIn && classes.root}>
      <Section className={classes.section}>
        <div className={classes.formContainer}>
          <img src={error404} alt="404" />
          <SectionHeader
            subtitle={
              <span>
                There’s nothing here, but if you feel this is an error please{' '}
                <LearnMoreLink
                  title="let us know"
                  href="#"
                  typographyProps={{ variant: 'h6' }}
                />
              </span>
            }
            titleProps={{
              variant: 'h3',
            }}
            labelProps={{
              color: 'secondary',
              className: classes.label,
              variant: 'h5',
            }}
            ctaGroup={[
              <CustomButton
                className={classes.backButton}
                size="large"
                variant="contained"
                onClick={() => history.goBack()}
              >
                Go Back
              </CustomButton>,
            ]}
            disableGutter
          />
        </div>
      </Section>
    </div>
  )
}

export default NotFound
